
  import {Component, Vue} from 'vue-property-decorator';
  import {bus} from "@/plugins/bus";
  import {IReport} from "@/modules/Report/interfaces/report.interface";
  import {ReportPrintActions} from "@/modules/Report/mixins/print-data.mixin";
  import {IApp} from "@/interfaces/app.interface";
  import {isMobile} from "mobile-device-detect";
  import ReportThCell from "@/modules/Report/components/ReportThCell.vue";
  import {IAppMediaPopup} from "@/shared/AppMediaPopup/interfaces/app-media-popup.interface";
  import {IAuth} from "@/modules/Auth/interfaces/auth.interface";
  import {IMovementsReport} from "@/modules/Report/Movements/interfaces/movements-report.interface";
  import PayCell from "@/modules/Report/Movements/components/tableCells/PayCell.vue";
  import {movementsConfig} from "@/modules/Report/Movements/config/config-movements";
  import {IBook} from "@/interfaces/book.interface";
  import MovementsTableTotal from "@/modules/Report/Movements/components/MovementsTableTotal.vue";
  import {openMediaPopup} from "@/modules/Report/Movements/helpers/open-media-popup";
  import ActionsCell from "@/modules/Report/Movements/components/tableCells/ActionsCell.vue";
  import CarNumberCell from "@/modules/Report/components/events/CarNumberCell.vue";
  import {ICarStore} from "@/modules/Car/interfaces/car-store.interface";
  import ChangeMovementActionBtn
    from "@/modules/Report/Movements/components/specialComponents/ChangeMovementActionBtn.vue";
  import ActionsDropdown from "@/modules/Report/Movements/components/specialComponents/ActionsDropdown.vue";

  @Component({
    components: {
      ActionsDropdown,
      ChangeMovementActionBtn,
      CarNumberCell,
      ActionsCell,
      MovementsTableTotal,
      PayCell,
      ReportThCell,
    }
  })
  export default class ReportTableMovements extends Vue {

    cellType = IApp.SortingPropType;
    isMobile = isMobile;

    get userAccess(): IAuth.UserAccess { return this.$store.state.auth.userAccess; }
    get tableList(): IMovementsReport.IDataItem[] {
      return this.$store.getters['report/sortedList'].array.map(row => {
        let resultData = {...row,};
        this.dataProps.forEach(cell => {
          switch (cell.propType) {
            case IApp.SortingPropType.Number:
              resultData[`${cell.prop}Printed`] = row[cell.prop] ? this.$options.filters.currency(row[cell.prop], cell.isMoney ? '₽' : '') : '';
              break;

            case IApp.SortingPropType.Date:

              if (cell.useCustomDateFormat && row[cell.prop]) {
                let day = this.$options.filters.moment(row[cell.prop], 'DD');
                let month = this.$options.filters.moment(row[cell.prop], 'MMMM');
                if (month) month = month.slice(0, 3);
                let time = this.$options.filters.moment(row[cell.prop], IApp.DateFormats.PrintedTime);
                resultData[`${cell.prop}Printed`] = `${day} ${month} ${time}`;
              }
              else {
                resultData[`${cell.prop}Printed`] = this.$options.filters.moment(row[cell.prop], cell.dateFormat);
              }
              break;

            default:
              break;
          }

          if (cell.prop === 'dateIn') {
            cell.addClassFunction = (value) => value.dateIn && !value.dateOut ? 'blue' : '';
          }
          if (cell.prop === 'dateOut') {
            cell.addClassFunction = (value) => value.dateOut ? 'green' : '';
          }
          if (cell.prop === 'payGuestHoursMov') {
            cell.addClassFunction = (value) => !value.payGuestHoursMov && value.payGuestHoursMov !== 0 ? 'bg--red-light' : '';
          }
          if (cell.prop === 'corpName') {
            cell.addClassFunction = (value) => value.unknownCarFlag ? 'color--red' : '';
          }
          if (cell.prop === 'carTypeName') {
            let text = `${row.visitPurposeName || ''}`;
            if (row.carTypeName && row.visitPurposeName) text += `<br>`;
            text += `${row.carTypeName || ''}`;
            resultData.carTypeName = text;
          }
          if (cell.prop === 'timePark') {
            let text = this.parseSeconds(row[cell.prop]);
            resultData.timeParkPrinted = text;
          }
        });

        return resultData;
      });
    }
    get dataProps(): IReport.ITableProp[] {
      let configType = IMovementsReport.TableConfigType.Default;
      let parks: IBook.ParkBookItem[] = this.$store.getters['book/parksBook'];

      let differentPark = parks.find(item => item.rptMovsTypeId !== parks[0].rptMovsTypeId);
      let allParksHasOneType = !Boolean(differentPark);

      let filterParks = this.$store.state.report.filters.parks;
      if (filterParks.length || allParksHasOneType) {
        if (allParksHasOneType) {
          configType = parks[0].rptMovsTypeId;
        }
        else {
          let selectedPark = parks.find(park => park.id === filterParks[0]);
          if (selectedPark && selectedPark.rptMovsTypeId) {
            configType = selectedPark.rptMovsTypeId;
          }
        }
      }
      return movementsConfig.getTableCells(this.appTableV2, configType);
    }
    get printedOptions() {
      return {
        $options: this.$options,
        tableList: this.tableList,
        dataProps: this.dataProps,
      };
    }
    get activeReport() { return this.$store.state.report.activeReport; }
    get appTableV2() {
      // let storageValue = localStorage.getItem(IApp.LocalStorageKeys.AppTableV2);
      // return storageValue ? JSON.parse(storageValue) : false;
      return [IReport.ReportName.Movement].includes(this.activeReport);
    }

    async mounted() {
      bus.$on(IAppMediaPopup.EmitterEvents.ToggleEntityTo + IAppMediaPopup.MediaPopupSourceCall.ReportMovements,
        async ({ indexRow, direction }) => {
        let index = indexRow;
        if (direction === +1) index = indexRow === this.tableList.length - 1 ? 0 : indexRow + direction;
        else index = indexRow === 0 ? this.tableList.length - 1 : indexRow + direction;
        await this.openMediaPopup(this.tableList[index], index);
      });
    }

    async reloadData() {
      await this.$store.dispatch('report/getReport', {
        reportName: this.$store.state.report.activeReport,
        filters: {...this.$store.state.report.filters},
      });
    }

    printTable() {
      ReportPrintActions.PrintTable(this.printedOptions);
    }

    prepareExcel() {
      return ReportPrintActions.PrepareExcel(this.printedOptions);
    }

    async cellClick(tableItem: IMovementsReport.IDataItem, propName: string) {
      if (propName === 'carNumber') await this.openCarPopup(tableItem);
    }

    async openCarPopup(tableItem: IMovementsReport.IDataItem) {
      let payload: ICarStore.IPopupPayload = {};
      if (+tableItem.carId > 0 || +tableItem.carId < 0) {
        payload.carId = tableItem.carId;
      }
      else {
        payload.createMode = true;
        payload.carNumber = tableItem.carNumber;
        payload.presetFields = [
          { prop: 'carNumber', value: tableItem.carNumber, },
        ];
      }
      payload.closeAction = async () => {
        this.reloadData();
      };
      await this.$store.dispatch('car/openCarPopup', payload);
    }

    async openMediaPopup(item: IMovementsReport.IDataItem, index: number) {
      await openMediaPopup({ item, index, tableList: this.tableList, fromCarPopup: false });
    }

    parseSeconds(seconds) {
      if (!seconds || seconds < 0) return '00:00';

      // Округляем секунды в большую сторону
      const totalMinutes = Math.ceil(seconds / 60);

      const hours = Math.floor(totalMinutes / 60);
      const mins = totalMinutes % 60;

      const format = (num) => String(num).padStart(2, '0');

      return `${format(hours)}:${format(mins)}`;
    }

    destroyed() {
      bus.$off(IAppMediaPopup.EmitterEvents.ToggleEntityTo + IAppMediaPopup.MediaPopupSourceCall.ReportMovements);
    }
  }
